import React from 'react';
import '../styles/BYOBSection.css';
import pr5 from '../assets/pr5.png'
import pr6 from '../assets/bg6.png'
import pr7 from '../assets/bg7.png'
import pr8 from '../assets/bg8.png'
import pr9 from '../assets/bg5.png'
import pr10 from '../assets/pr10.png'
import pr12 from '../assets/pr12.png'
import pr13 from '../assets/13.png'
import pr14 from '../assets/pr14.png'
import pr15 from '../assets/pr15.png'
import pr16 from '../assets/pr16.png'
import pr17 from '../assets/pr17.png'
import icon1 from '../assets/icon1.png'
import icon2 from '../assets/icon2.png'
import icon3 from '../assets/icon3.png'
import icon4 from '../assets/icon4.png'
import icon5 from '../assets/icon5.png'

const BYOBSection = () => {
  const benefits = [
    {
      id: 1,
      title: 'Custom Branding',
      description: 'Your logo, your packaging, your identity. We help you create a brand that stands out.',
      highlight: '100% Private Label',
      image: pr6,
    },
    {
      id: 2,
      title: 'Low Minimum Order',
      description: 'Start small, grow big. Flexible MOQs for small retail chains and emerging distributors.',
      highlight: 'No High Investment',
      image: pr7
    },
    {
      id: 3,
      title: 'Quick Turnaround',
      description: 'From order confirmation to production and dispatch, our streamlined process ensures smooth coordination and reliable service for your business.',
      highlight: 'Reliable Service',
      image: pr8
    },
    {
      id: 4,
      title: 'End-to-End Support',
      description: 'Marketing materials, technical support, and after-sales service at every step.',
      highlight: 'Complete Support',
      image: pr9
    }
  ];

  const howItWorks = [
    {
      step: '01',
      title: 'Share Your Vision',
      description: 'Tell us your brand requirements and target audience.',
      icon: icon1
    },
    {
      step: '02',
      title: 'Get Custom Quote',
      description: 'Receive tailored proposal with pricing and timeline.',
      icon: icon2
    },
    {
      step: '03',
      title: 'Manufacturing',
      description: 'We manufacture with strict quality control.',
      icon: icon4
    },
    {
      step: '04',
      title: 'Launch Your Brand',
      description: 'Receive products and start selling under your brand.',
      icon: icon5
    }
  ];

  return (
    <section id="byob-program" className="byob-program-section">
      <div className="byob-program-container">

        {/* Hero Visual Banner */}
        <div className="byob-program-hero-visual">
          <div className="byob-program-hero-left">
            <span className="byob-program-badge">✨ Revolutionary Concept ✨</span>
            <h1 className="byob-program-hero-title">
              Build Your Own <span className="byob-program-hero-highlight">Brand</span>
            </h1>
            <p className="byob-program-hero-description">
              An entirely new concept in the Indian hearing aid industry. 
              Become a private label partner and create your own successful hearing aid brand.
            </p>
            <div className="byob-program-hero-features">
              <div className="byob-program-hero-feature">
                <span>✓</span> 100% Ownership
              </div>
              <div className="byob-program-hero-feature">
                <span>✓</span> Pan-India Support
              </div>
            </div>
          </div>
          <div className="byob-program-hero-right">
            <div className="byob-program-hero-image-wrapper">
              <img 
                src={pr5} 
                alt="BYOB Program - Build Your Own Brand"
                className="byob-program-hero-image"
              />
             
            </div>
          </div>
        </div>

   

        {/* Benefits with Images */}
        <div className="byob-program-benefits">
          <div className="byob-program-section-header">
            <h2>The BYOB Advantage</h2>
            <p>Everything you need to build a successful hearing aid brand</p>
          </div>
          <div className="byob-program-benefits-grid">
            {benefits.map((benefit) => (
              <div key={benefit.id} className="byob-program-benefit-card">
                <div className="byob-program-benefit-image">
                  <img src={benefit.image} alt={benefit.title} />
                </div>
                <h3 className="byob-program-benefit-title">{benefit.title}</h3>
                <p className="byob-program-benefit-description">{benefit.description}</p>
                <div className="byob-program-benefit-highlight">{benefit.highlight}</div>
              </div>
            ))}
          </div>
        </div>

        {/* How It Works - Visual Timeline with Icon Images */}
        <div className="byob-program-how-it-works">
          <div className="byob-program-section-header">
            <h2>Simple 4-Step Process</h2>
            <p>Launch your own brand in just 4 easy steps</p>
          </div>
          <div className="byob-program-visual-timeline">
            {howItWorks.map((step, index) => (
              <div key={step.step} className="byob-program-timeline-item">
                <div className="byob-program-timeline-icon-wrapper">
                  <div className="byob-program-timeline-icon">
                    <img src={step.icon} alt={step.title} />
                  </div>
                  <div className="byob-program-timeline-number">{step.step}</div>
                </div>
                <div className="byob-program-timeline-content">
                  <h4>{step.title}</h4>
                  <p>{step.description}</p>
                </div>
                {index < howItWorks.length - 1 && (
                  <div className="byob-program-timeline-arrow">→</div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Target Audience with Visual Cards */}
        <div className="byob-program-target">
          <div className="byob-program-section-header">
            <h2>Perfect For</h2>
            <p>Join hundreds of successful partners across India</p>
          </div>
          <div className="byob-program-target-grid">
           
            <div className="byob-program-target-card">
              <div className="byob-program-target-visual">
                <img src={pr12} alt="Distributors" />
              </div>
              <h3>Distributors</h3>
              <p>Build exclusive brand rights in your territory</p>
            </div>
            <div className="byob-program-target-card">
              <div className="byob-program-target-visual">
                <img src={pr13} alt="Retail Chains" />
              </div>
              <h3>Retail Chains</h3>
              <p>Differentiate from competitors with unique products</p>
            </div>
            <div className="byob-program-target-card">
              <div className="byob-program-target-visual">
                <img src={pr14} alt="Buying Groups" />
              </div>
              <h3>Buying Groups</h3>
              <p>Leverage collective buying power for custom branding</p>
            </div>
          </div>
        </div>

       
      </div>
    </section>
  );
};

export default BYOBSection;